import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { I18nTranslationFragment } from '@/helpers/api/fragments'

const output = `
    ...I18nTranslation
`

const fragments = gql`
  ${I18nTranslationFragment}
`

const allowedFields = [
  'key',
  'locale',
  'translation',
  'customer_id',
  'uploaded_at'
]

export default config => {
  const service = createService({
    ...config,
    table: 'i18n_translation',
    defaultPageSize: 25,
    defaultOrderBy: [{ key: 'asc' }],
    primaryKey: ['key', 'locale'],
    defaultSearchBy: ['key', 'locale', 'translation'],
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    allowedFields
  })

  return {
    ...service
  }
}
